export const optimizeQueryParams = (params, filterToCompare = []) => params.length > 0 && params.length !== filterToCompare.length;



// WEBPACK FOOTER //
// ./src/app/helpers/optimize-query-params.js